// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_2JDpXI69Mnum40aO2NggJr","modalTitle":"_1AsO3QmHqQ37rTbASztzHW","kidImg":"_4Pj4jfEz8iFzwp4SplMpy"};